import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Switch } from 'components/atoms/switch/switch';
import { GlobalSettingsEnableSwitcher } from 'components/molecules/settings/global-setting-enable-switcher';
import { BodyShort01 } from 'components/styles';
import { useAntdRlUISwitcher } from 'contexts/antd-rlui-switcher';
import { Section } from './components';
const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
`;
const SectionWrapper = styled(Section)`
  padding-top: 0;
  padding-bottom: var(--spacing-04);
`;
const Description = styled.div`
  ${BodyShort01};
  color: var(--gray-70);
  margin-top: var(--spacing-02);
  margin-bottom: var(--spacing-05);
`;
export const FeatureSwitch = ({ enabled, onStateChange })=>{
    const isNew = useAntdRlUISwitcher();
    return /*#__PURE__*/ _jsx(SectionWrapper, {
        children: isNew ? /*#__PURE__*/ _jsx(GlobalSettingsEnableSwitcher, {
            onChangeSettings: (checked)=>onStateChange(checked),
            enableSetting: enabled,
            title: /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "settings.credit_notes_essentials.title"
            }),
            description: /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "settings.credit_notes.enable_message"
            }),
            dataCy: "switch.credit-note-feature"
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Description, {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "settings.credit_notes.enable_message"
                    })
                }),
                /*#__PURE__*/ _jsxs(SwitchWrapper, {
                    "data-cy": "switch-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx(Switch, {
                            size: "small",
                            checked: enabled,
                            onChange: (checked)=>onStateChange(checked),
                            "data-cy": "switch.credit-note-feature"
                        }),
                        enabled ? /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "enabled"
                        }) : /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "disabled"
                        })
                    ]
                })
            ]
        })
    });
};
